<div
  class="chat-overlay"
  [class.mode-panel]="mode === 'panel'"
  [class.mode-expanded]="mode === 'expanded'"
  [class.mode-full]="mode === 'full'"
  >
  <header class="overlay-header">
    <div class="header-title">
      <ion-icon name="chatbubbles-outline"></ion-icon>
      <span>Solo Assistant</span>
    </div>
    @if (mode !== 'panel') {
      <button
        class="header-btn mode-toggle"
        type="button"
        [title]="mode === 'full' ? 'Shrink to window' : 'Collapse to sidebar'"
        [attr.aria-label]="mode === 'full' ? 'Shrink chat to window' : 'Collapse chat to sidebar'"
        (click)="collapseMode()"
        >
        <ion-icon name="contract-outline"></ion-icon>
      </button>
    }
    @if (mode !== 'full') {
      <button
        class="header-btn mode-toggle"
        type="button"
        [title]="mode === 'panel' ? 'Expand chat' : 'Expand to fullscreen'"
        [attr.aria-label]="mode === 'panel' ? 'Expand chat' : 'Expand chat to fullscreen'"
        (click)="expandMode()"
        >
        <ion-icon name="expand-outline"></ion-icon>
      </button>
    }
    <button
      class="header-btn"
      type="button"
      title="Close chat"
      aria-label="Close chat"
      (click)="close()"
      >
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </header>

  <div class="overlay-body">
    <div
      class="threads-backdrop"
      [class.visible]="threadsOpen"
      (click)="closeThreadsPanel()"
      aria-hidden="true"
    ></div>

    <aside class="threads-column" [class.open]="threadsOpen">
      <div class="column-header">
        <h2>Chats</h2>
        <div class="column-header-actions">
          <ion-button fill="clear" size="default" aria-label="Create chat" (click)="createThread()">
            <ion-icon name="add-outline" slot="icon-only"></ion-icon>
          </ion-button>
          <ion-button
            class="threads-close"
            fill="clear"
            size="default"
            aria-label="Close chat list"
            (click)="closeThreadsPanel()"
            >
            <ion-icon name="close-outline" slot="icon-only"></ion-icon>
          </ion-button>
        </div>
      </div>

      <label class="search-label" for="overlay-thread-search">Search</label>
      <input
        id="overlay-thread-search"
        class="thread-search"
        type="search"
        placeholder="Find a chat"
        [value]="threadQuery"
        (input)="onThreadSearchInput($event)"
        />

      <div class="thread-list">
        @if (loadingThreads) {
          <div class="thread-list-status">Loading chats...</div>
        }

        @for (thread of filteredThreads; track thread) {
          <button
            class="thread-card"
            type="button"
            (click)="selectThread(thread.id)"
            [class.active]="thread.id === selectedThreadId"
            >
            <div class="thread-meta">
              <h3>{{ thread.title }}</h3>
              <span class="thread-time">{{ thread.updated }}</span>
            </div>
          </button>
        }

        @if (!loadingThreads && filteredThreads.length === 0) {
          <div class="thread-list-status">
            No chats found.
          </div>
        }
      </div>
    </aside>

    <section class="chat-column">
      <div class="mode-bar">
        <button
          class="threads-toggle"
          type="button"
          aria-label="Open chat list"
          (click)="toggleThreadsPanel()"
          >
          <ion-icon name="chatbubbles-outline"></ion-icon>
          <span>Chats</span>
        </button>

        <label class="selector-group">
          <span>Model</span>
          <select
            [value]="selectedModelCode || ''"
            [disabled]="availableModels.length === 0"
            (change)="onModelChange($event)"
            >
            @if (availableModels.length === 0) {
              <option value="" disabled>
                {{ modelOptionsError || 'No models available' }}
              </option>
            }
            @for (model of availableModels; track model) {
              <option
                [value]="model.modelCode"
                >
                {{ model.displayName }} ({{ model.providerDisplayName }}) — {{ formatMultiplierBadge(model) }}
              </option>
            }
          </select>
        </label>

        @if (selectedThreadId) {
          <button
            class="copy-id-btn"
            type="button"
            [title]="'Copy Chat ID: ' + selectedThreadId"
            (click)="copyThreadId()"
            >
            <ion-icon [name]="threadIdCopied ? 'checkmark-outline' : 'copy-outline'"></ion-icon>
            <span>{{ threadIdCopied ? 'Copied!' : 'Copy Chat ID' }}</span>
          </button>
        }
      </div>

      <div class="chat-body">
        @if (loading) {
          <div class="loading-state">
            <ion-icon name="time-outline"></ion-icon>
            <h3>Connecting chat...</h3>
            <p>Loading your assistant workspace.</p>
          </div>
        }

        @if (!loading && error) {
          <div class="error-state">
            <h3>Chat unavailable</h3>
            <p>{{ error }}</p>
            <ion-button fill="outline" (click)="retry()">Retry</ion-button>
          </div>
        }

        <openai-chatkit
          #chatkitElement
          class="chatkit-surface"
          [class.hidden]="loading || !!error"
        ></openai-chatkit>

        @if (voiceInputEnabled && !loading && !error) {
          <app-voice-input
            class="voice-input-anchor"
            (transcript)="onVoiceTranscript($event)"
          ></app-voice-input>
        }
      </div>
    </section>
  </div>
</div>
